import "./Icon.scss"

export function Icon({ src, className = "", onClick = () => {} }) {
  const formattedPath = src?.split(".")[0] || ""
  const iconStyle = { "--mask-image": `url(${window.location.origin}${formattedPath}.svg)` }

  return <span className={`Icon ${className}`} style={iconStyle} alt={className} onClick={onClick} />
}
